import { TransformRuleFactory } from "../transformation/factory/TransformRuleFactory";
import {
  TransformRule,
  TransformRuleData,
} from "../transformation/TransformRule";
import { ValidationRule } from "../validation/ValidationRule";
import { ValidationRuleSet } from "../validation/ValidationRuleSet";
// import { BatchClassConfig } from './BatchClassConfig';

export { BaseFieldConfig, BaseFieldConfigData };

type BaseFieldConfigData = {
  fieldName: string;
  description: string;
  /**
   * field display position within Accelerator
   */
  position: number;
  displayTab: string;
  threshold: number;
  ocrConfidenceThreshold: number;
  hidden: boolean;
  generateReuse: boolean;
  applyReuse: boolean;
  multiline?: boolean;
  /** Reporting groups documents by this field's value. At most one per document type. */
  aggregationField?: boolean;
  /** This field's value is the document's monetary amount for reporting. At most one per type. */
  valueField?: boolean;

  validator: ValidationRuleSet;

  transformationRules: TransformRuleData[];
};

class BaseFieldConfig {
  static DEFAULT_GENERATE_REUSE: boolean = true;
  static DEFAULT_THRESHOLD: number = 50;
  static DEFAULT_OCR_THRESHOLD: number = 90;

  fieldName: string;
  // unused
  description: string;
  position: number;
  displayTab: string;
  hidden: boolean;
  generateReuse: boolean;
  applyReuse: boolean;
  multiline: boolean;
  aggregationField: boolean;
  valueField: boolean;

  validator: ValidationRuleSet;

  transformationRules: TransformRule[];

  threshold: number;
  /**
   * Default OCR Confidence for DLF
   */
  ocrConfidenceThreshold: number;

  constructor(data: BaseFieldConfigData) {
    this.fieldName = data.fieldName;
    this.description = data.description ?? "";
    this.position = data.position;
    this.displayTab = data.displayTab ?? "";

    this.hidden = data.hidden;
    this.applyReuse = data.applyReuse;
    this.generateReuse = data.generateReuse;
    this.threshold = data.threshold;
    this.ocrConfidenceThreshold =
      data.ocrConfidenceThreshold ?? BaseFieldConfig.DEFAULT_OCR_THRESHOLD;
    this.multiline = data.multiline ?? false;
    // Defaulted rather than required, so a config saved before these existed still loads.
    this.aggregationField = data.aggregationField ?? false;
    this.valueField = data.valueField ?? false;

    if (data.validator) {
      this.validator = {
        clientValidationOperator: data.validator.clientValidationOperator,
        fieldName: data.validator.fieldName,
        validationRules: data.validator.validationRules.map(
          (x) => new ValidationRule(x),
        ),
      };
    } else {
      this.validator = {
        clientValidationOperator: "OR",
        fieldName: data.fieldName,
        validationRules: [],
      };
    }

    this.transformationRules = (data.transformationRules ?? [])
      .sort((a, b) => a.position - b.position)
      .map(TransformRuleFactory.createRule);
  }

  setTransformRules(rules: TransformRule[]) {
    this.transformationRules = rules;
  }

  get actualPosition(): number {
    const helios = (this as any).helios;
    const pos =
      helios && helios.position !== undefined ? helios.position : this.position;
    return pos !== undefined && pos !== null && !isNaN(Number(pos))
      ? Number(pos)
      : 0;
  }

  get actualHidden(): boolean {
    // Hiding in Accelerator's own UI is independent of helios.hidden, which
    // only controls visibility in the external Operator UI.
    return this.hidden;
  }
}
